import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class MulkiyetDurumuAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "MulkiyetDurumuListe";
    super(baseUrl);
  }


  getMulkiyetDurumuListe( request?: any){
    return this.get("",request);
  }

}
export default new MulkiyetDurumuAPI();
class MulkiyetDurumuRequest {
  public MulkiyetDurumuKodu?: number;

  constructor( kullanimSekliKodu?: number) {
   
        this.MulkiyetDurumuKodu = kullanimSekliKodu;

  }
}
export { MulkiyetDurumuRequest };